import { useAdminApi } from '@hooks/useAdminApi';
import { ORGANIZATION_COLUMNS, ORGANIZATION_FILTERS } from '@protos/organization';
import { BlotterWidget } from '@shared/components/BlotterWidget';
import { usePageTitle } from '@shared/hooks/usePageTitle';
import { ColDef } from 'ag-grid-enterprise';
import { useEffect, useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

const getRowId = ({ data }): string => data?.id?.toString();

const defaultColDef = (navigate: NavigateFunction) => {
  return {
    onCellClicked(event) {
      if (event.column.getColId() === 'id') {
        navigate(`/organizations/${event.data.id}`);
      }
    },
    cellStyle(params) {
      if (params.column.getColId() === 'id') {
        return { cursor: 'pointer' };
      }
      return null;
    },
  } as ColDef;
};

export const OrganizationsPage = () => {
  usePageTitle('Organizations - Admin');
  const { apiClient } = useAdminApi();
  const dataLoader = apiClient?.organizationsLoader();
  const navigate = useNavigate();

  const [gridHeight, setGridHeight] = useState(() => {
    return document.documentElement.clientHeight - 100;
  });

  useEffect(() => {
    const updateHeight = () => {
      setGridHeight(document.documentElement.clientHeight - 100);
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  if (!dataLoader) return null;

  return (
    <BlotterWidget
      dataLoader={dataLoader}
      columnDefs={ORGANIZATION_COLUMNS}
      getRowId={getRowId}
      maxHeight={gridHeight}
      filters={ORGANIZATION_FILTERS}
      defaultColDef={defaultColDef(navigate)}
      autoSizeStrategy={{ type: 'fitGridWidth' }}
    />
  );
};
